import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/auth/AuthContext";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { CookieConsent } from "@/components/CookieConsent";
import { Landing } from "@/pages/Landing";
import { Login } from "@/pages/Login";
import { AdminDashboard } from "@/pages/AdminDashboard";
import { PrivacyPolicy } from "@/pages/PrivacyPolicy";
import { CookiePolicy } from "@/pages/CookiePolicy";

function Inner() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "hsl(213 52% 13%)",
                border: "1px solid hsl(213 41% 22%)",
                color: "#E8ECF2",
              },
            }}
          />
          <Inner />
          <CookieConsent />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
